import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back.");
      navigate("/admin");
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  const inputCls = "w-full bg-white/[0.04] border border-white/10 rounded-lg px-4 py-3 text-sm text-white placeholder:text-muted outline-none focus:border-orange focus:ring-1 focus:ring-orange/60";

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-5" data-testid="login-page">
      <div className="ambient-orange pointer-events-none absolute left-1/4 top-1/4 h-[400px] w-[400px]" />
      <div className="glass relative w-full max-w-md rounded-2xl p-8">
        <img src="/dna-logo.png" alt="DNA eCommerce Ads" className="mb-8 h-10 w-auto" />
        <h1 className="font-display text-2xl font-bold">Admin Login</h1>
        <p className="mb-6 mt-1 text-sm text-muted">Manage leads and blog content.</p>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="login-email" type="email" className={inputCls} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" type="password" className={inputCls} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button data-testid="login-submit" disabled={loading} className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-orange to-magenta px-6 py-3 text-sm font-semibold text-white disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
